<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
<!--            <Button type="primary" @click="modal1=true">增加</Button>-->
            &nbsp;
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="编号" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="gs" label="公司" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="xm" label="姓名" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="sj" label="手机" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="unionid" label="小程序用户ID" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)" v-if="power.indexOf(17)!=-1">编辑</a>

            <span v-if="power.indexOf(18)!=-1">
              <cite>|</cite>
              <a @click="remove(scope.row.id)">删除</a>
            </span>

          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">
       				<FormItem label="编号">
					<Input v-model="detail.id"/>
				</FormItem>
				<FormItem label="公司">
					<Input v-model="detail.gs"/>
				</FormItem>
				<FormItem label="姓名">
					<Input v-model="detail.xm"/>
				</FormItem>
				<FormItem label="手机">
					<Input v-model="detail.sj"/>
				</FormItem>
				<FormItem label="创建时间">
					<Input v-model="detail.ctime"/>
				</FormItem>
				<FormItem label="小程序用户ID">
					<Input v-model="detail.unionid"/>
				</FormItem>

      </Form>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        power:this.$storage.getSession('power'),
        baseUrl:'/api/goumai/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lanka/Goumai.vue